module.exports = __webpack_public_path__ + "img/brazil.23c03a16.svg";